import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 -39 471.584 471" className={className} {...size}>
    <path
      d="M272 125.402h-16V104.86A143.6 143.6 0 0 1 298.344 2.637l11.312 11.312A127.715 127.715 0 0 0 272 104.86zm0 0"
      fill="#8d6339"
    />
    <path
      d="M196 .293c39.766 0 72 32.234 72 72-39.766 0-72-32.238-72-72zm0 0M160 152.293h-40c-48.602 0-88-39.398-88-88v-40h40c48.602 0 88 39.398 88 88zm0 0"
      fill="#8ac03f"
    />
    <path
      d="M165.656 146.637L104 84.98V48.293H88V68.98L61.656 42.637 50.344 53.949l26.343 26.344H56v16h36.688l61.656 61.656zm0 0"
      fill="#c6db5b"
    />
    <path
      d="M189.238 80.293c-37.527 0-71.84 21.207-88.62 54.773A119.435 119.435 0 0 0 88 188.492c0 28.871 6.129 57.414 17.977 83.742l35.625 79.258c11.191 24.86 35.937 40.832 63.199 40.801 7.437 0 14.828-1.2 21.887-3.555L264 376.293l37.344 12.445a69.154 69.154 0 0 0 21.855 3.555c27.266.031 52.008-15.941 63.2-40.8l35.656-79.2a204.073 204.073 0 0 0 17.945-83.8c0-18.548-4.32-36.837-12.617-53.427-16.781-33.566-51.09-54.773-88.621-54.773a99.08 99.08 0 0 0-61.907 21.71L264 112.294l-12.855-10.29a99.08 99.08 0 0 0-61.907-21.71zm0 0"
      fill="#ec4042"
    />
    <path
      d="M205.45 273.676c11.769 51.496-20.274 102.828-71.708 114.867-51.433 12.039-102.93-19.738-115.238-71.106-12.106-51.625-3.488-155.296 58.832-169.882 62.32-14.582 116.031 74.496 128.113 126.12zm0 0"
      fill="#89b33b"
    />
    <path
      d="M175.977 295.555c0 35.347-28.657 64-64 64-35.348 0-64-28.653-64-64 0-35.344 28.652-64 64-64 35.343 0 64 28.656 64 64zm0 0"
      fill="#fae100"
    />
    <path
      d="M17.602 392.293h353.062a51.504 51.504 0 0 0 36.426-15.09l4.496-4.496c20.086-20.11 20.086-52.691 0-72.8a51.52 51.52 0 0 0-46.723-14.048L14.098 357.41A17.603 17.603 0 0 0 0 374.691c0 9.723 7.879 17.602 17.602 17.602zm0 0"
      fill="#ffc117"
    />
    <path
      d="M465.648 328.125l-3.296-15.664-18.399 3.879 10.656-15.528-13.203-9.039-21.949 32a8.001 8.001 0 0 0 .75 9.993l29.961 32 11.68-10.946-20.254-21.601zm0 0"
      fill="#8ac03f"
    />
    <path
      d="M456.418 142.531a143.504 143.504 0 0 0-5.465-13.8l14.543-6.657a157.84 157.84 0 0 1 6.09 15.356zm0 0M443.2 114.195a122.127 122.127 0 0 0-104.438-57.902c-3.403 0-6.778.145-10.153.422l-1.351-15.934c3.816-.328 7.652-.488 11.504-.488 48.054-.215 92.765 24.578 118.039 65.453zm0 0"
      fill="#ccdde6"
    />
    <g fill="#fdad2a">
      <path d="M134.727 362.988a77.074 77.074 0 0 0 4.472-29.472v-1.602l-16 3.266a61.674 61.674 0 0 1-3.535 22.449zm0 0M174.785 350.691l15.07 5.395a78.446 78.446 0 0 0 4.122-34.402l-.075-.97-15.812 3.2a62.384 62.384 0 0 1-3.305 26.777zm0 0M229.902 343.844l15.075 5.375a79.114 79.114 0 0 0 3.48-39.32l-.05-.301-15.712 3.199a62.939 62.939 0 0 1-2.793 31.047zm0 0M285.023 336.965l15.075 5.375a78.712 78.712 0 0 0 2.597-43.824l-15.664 3.199.047.2a62.704 62.704 0 0 1-2.055 35.05zm0 0M348.184 318.738l-.801 3.051 15.472 4.055.801-3.055a79.365 79.365 0 0 0 .696-36.855l-15.641 3.199v.101a63.25 63.25 0 0 1-.527 29.504zm0 0" />
    </g>
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
